__turbopack_context__.v({
  "body": "news-feed-module__cMcX2G__body",
  "card": "news-feed-module__cMcX2G__card",
  "card-in": "news-feed-module__cMcX2G__card-in",
  "corner": "news-feed-module__cMcX2G__corner",
  "date": "news-feed-module__cMcX2G__date",
  "dateCornerEnd": "news-feed-module__cMcX2G__dateCornerEnd",
  "dateCornerTop": "news-feed-module__cMcX2G__dateCornerTop",
  "excerpt": "news-feed-module__cMcX2G__excerpt",
  "feed": "news-feed-module__cMcX2G__feed",
  "icon": "news-feed-module__cMcX2G__icon",
  "media": "news-feed-module__cMcX2G__media",
  "more": "news-feed-module__cMcX2G__more",
  "pin": "news-feed-module__cMcX2G__pin",
  "pinCornerBottom": "news-feed-module__cMcX2G__pinCornerBottom",
  "pinCornerStart": "news-feed-module__cMcX2G__pinCornerStart",
  "pulse": "news-feed-module__cMcX2G__pulse",
  "sentinel": "news-feed-module__cMcX2G__sentinel",
  "skeleton": "news-feed-module__cMcX2G__skeleton",
  "skeletonLine": "news-feed-module__cMcX2G__skeletonLine",
  "skeletonMedia": "news-feed-module__cMcX2G__skeletonMedia",
  "title": "news-feed-module__cMcX2G__title",
  "vinyl": "news-feed-module__cMcX2G__vinyl",
  "vinyl-spin": "news-feed-module__cMcX2G__vinyl-spin",
  "year": "news-feed-module__cMcX2G__year",
});
